import { useQuery } from "@tanstack/react-query"

import {
  getMyFilesNoSession,
  searchKnowledgeLibrary,
  searchMyFilesNoSession
} from "~/api/library"
import useGlobalStore from "~/store/global"
import { ITokenInfo } from "~/types/global"

export function useGetMyFilesNoSession(params: {
  search?: string
  tagIds?: string[]
}) {
  const tokenInfo = useGlobalStore((s) => s.tokenInfo)
  return useQuery({
    queryKey: ["my-files-no-session", params.search, params.tagIds?.join(",")],
    queryFn: async () => {
      const res = await getMyFilesNoSession(tokenInfo as ITokenInfo, params)
      return res.data?.data ?? { files: [] }
    },
    enabled: !!tokenInfo
  })
}

export function useSearchMyFilesNoSession(params: {
  query: string
  offset: number
  size: number
}) {
  const tokenInfo = useGlobalStore((s) => s.tokenInfo)
  return useQuery({
    queryKey: ["search-my-files-no-session", params.query, params.offset],
    queryFn: async () => {
      const res = await searchMyFilesNoSession(tokenInfo as ITokenInfo, params)
      return res.data?.data ?? { files: [] }
    },
    enabled: !!tokenInfo
  })
}

export function useSearchKnowledgeLibrary(params: {
  search?: string
  tagIds?: string[]
}) {
  const tokenInfo = useGlobalStore((s) => s.tokenInfo)
  return useQuery({
    queryKey: ["knowledge-library", params.search, params.tagIds?.join(",")],
    queryFn: async () => {
      const res = await searchKnowledgeLibrary(tokenInfo as ITokenInfo, params)
      return res.data?.data ?? { sources: [] }
    },
    // Allow empty search — backend returns all KB files when search=''
    enabled: !!tokenInfo
  })
}
